import { SettingOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Button, Form, Modal, StaticDropdown } from "src/Components";
import { ICCOrderCriterionTypes } from "src/Interfaces/ccOrder";
import { DeltaHedgeOrderType } from "src/Interfaces/deltaHedgeOrder";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { setCCOrderCriterionTypeDefaults } from "src/Requests/ccOrder";
import { packetErrorHandler } from "src/Utils/requestUtils";
import { toast } from "react-toastify";

interface IProps {
  orderType: DeltaHedgeOrderType | number | null | undefined;
  criterionTypes: ICCOrderCriterionTypes;
  criterionOptions: DropdownItem[];
  onSaved: (criterionTypes: ICCOrderCriterionTypes, criterionType: number) => void;
}

const CriterionTypeDefaultSetting = ({
  orderType,
  criterionTypes,
  criterionOptions,
  onSaved,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCriterionType, setSelectedCriterionType] =
    useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  const orderTypeKey = Number(orderType || -1);

  useEffect(() => {
    if (!isOpen) return;
    setSelectedCriterionType(criterionTypes.defaults?.[orderTypeKey] ?? null);
  }, [criterionTypes.defaults, isOpen, orderTypeKey]);

  const changeHandler = (_name: string, value: any) => {
    setSelectedCriterionType(value ? Number(value) : null);
  };

  const saveHandler = () => {
    if (!selectedCriterionType || !orderType) return;

    const updatedCriterionTypes = {
      ...criterionTypes,
      defaults: {
        ...criterionTypes.defaults,
        [orderTypeKey]: selectedCriterionType,
      },
    };

    setLoading(true);
    setCCOrderCriterionTypeDefaults({ defaults: updatedCriterionTypes.defaults })
      .then((resp) => {
        toast.success(resp.msg);
        onSaved(updatedCriterionTypes, selectedCriterionType);
        setIsOpen(false);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <>
      <button
        type="button"
        title="تنظیم پیش‌فرض نوع معیار"
        className="h-8 w-8 shrink-0 rounded border border-gray-300 text-gray-600 hover:border-gray-500 hover:text-gray-900"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setIsOpen(true);
        }}
      >
        <SettingOutlined />
      </button>

      {isOpen ? (
        <Modal
          onClose={() => setIsOpen(false)}
          modalBoxClassName="!w-[360px]"
          UI={
            <Form className="!w-full gap-5 p-3">
              <div className="text-sm font-medium">تنظیمات ارسال</div>
              <div className="w-[280px]">
                <StaticDropdown
                  dropdown={{
                    name: "criterionType",
                    placeholder: "نوع معیار پیش‌فرض",
                    extraLabel: true,
                  }}
                  value={selectedCriterionType}
                  onChange={changeHandler}
                  options={criterionOptions}
                />
              </div>
              <div className="w-[90px] mr-auto">
                <Button
                  text="ثبت"
                  variant="contained"
                  onClick={saveHandler}
                  disabled={!selectedCriterionType}
                  loading={loading}
                />
              </div>
            </Form>
          }
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default CriterionTypeDefaultSetting;
